import styled from 'styled-components';
import { StyleColor } from '../../utils/styles-constants';

const DropdownMenuList = styled('ul')`
	margin: 0;
	position: relative;
	border-radius: 16px;
	box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.19);
	background-color: ${StyleColor.White};
	list-style: none;
	padding: 8px 20px;
	min-width: 90px;
	z-index: 2;
`;

const DropdownMenuListItem = styled('li')`
	padding: 8px 0;
	text-align: center;
	cursor: pointer;
	border-bottom: 1px solid ${StyleColor.Grey50};
	font-weight: 600;

	&:last-of-type {
		border-bottom: none;
	}
`;

export { DropdownMenuList, DropdownMenuListItem };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SimpleDropdownMenu/styles.ts